import script from "./FifthTawafPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FifthTawafPage.vue?vue&type=script&setup=true&lang=js"

import "./FifthTawafPage.vue?vue&type=style&index=0&id=25e3c262&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25e3c262"]])

export default __exports__